/**
 * @file        src/api/wallets.js
 * @description Admin Wallet Management API calls (/api/wallets).
 * @author      Kinetika Labs
 * @created     2026-07-23
 * @changelog
 *   - 2026-07-23 Claude — Initial (Admin Wallet Management).
 */
import { get, post, put } from './client';

export const searchWalletUsers = (params) => get('/wallets/users', { params });
export const getWalletDetail = (userId) => get(`/wallets/users/${userId}`);
export const getWalletTransactions = (userId, params) => get(`/wallets/users/${userId}/transactions`, { params });
export const creditWallet = (userId, body) => post(`/wallets/users/${userId}/credit`, body);
export const refundWallet = (userId, body) => post(`/wallets/users/${userId}/refund`, body);
export const setWalletStatus = (userId, action) => post(`/wallets/users/${userId}/status`, { action });
export const getWalletSettings = () => get('/wallets/settings');
export const updateWalletSettings = (body) => put('/wallets/settings', body);

// --- Dues (2026-10-06) ------------------------------------------------------
// Settling a due is a SEPARATE action from crediting a wallet and deliberately
// so: a credit makes money spendable, a settlement only lowers what is owed.
// Both re-verify the admin's password server-side; the settlement audits as
// wallet.due_payment, or wallet.due_writeoff when it is forgiven rather than
// collected.
export const settleUserDue = (userId, body) => post(`/wallets/users/${userId}/due-payment`, body);
export const settleCompanyDue = (businessId, body) => post(`/wallets/companies/${businessId}/due-payment`, body);
